import { useEffect } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { patchAccountTimeZone } from '#action/user/settings';
import { getTimeZone } from '#helper';

/**
 * Patches user's timezone
 */

const usePatchTimezone = () => {
  const { id, timeZone } = useSelector(s => s.account, shallowEqual);
  const dispatch = useDispatch();

  useEffect(() => {
    if (id && timeZone !== undefined) {
      const currentTimezone = getTimeZone();
      if (currentTimezone && timeZone !== currentTimezone) {
        dispatch(patchAccountTimeZone(currentTimezone));
      }
    }
  }, [dispatch, id, timeZone]);
};

export default usePatchTimezone;
